<ng-container *ngIf="businessUnits$ | async as businessUnits">
  <div class="actions">
    <app-ag-grid-options
      [configStoreTableName]="configStoreTableName"
      [configStoreRouteIdName]="configStoreRouteIdName"
    ></app-ag-grid-options>
  </div>
  <ag-grid-angular
    columnHoverHighlight
    rowHoverHighlight
    class="ag-theme-adap ag-sticky"
    [rowData]="businessUnits"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [components]="components"
    domLayout="normal"
    rowClass="ag-no-border"
    configStore
    [configStoreTableName]="configStoreTableName"
    [configStoreRouteIdName]="configStoreRouteIdName"
    columnSizeStrategy="sizeColumnsToFit"
    suppressScrollOnNewData
  >
  </ag-grid-angular>
</ng-container>
